export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-navy-ink/10 bg-brand"
      data-testid="marquee-band"
      aria-hidden="true"
    >
      <div className="tape-ticks h-7" data-testid="tape-track" />
    </div>
  );
}
